import { useMemo } from 'react';

function hashKey(input) {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}

export default function useTableKey({ providedTableKey, pathname }) {
  const rawTableKey = useMemo(() => {
    if (providedTableKey) return providedTableKey;
    if (!pathname) return undefined;
    const pathKey = pathname
      .replace(/^\//, '')
      .replace(/\//g, '_')
      .replace(/[^a-zA-Z0-9_-]/g, '');
    return pathKey ? `table_${pathKey}` : undefined;
  }, [providedTableKey, pathname]);

  const tableKey = useMemo(() => {
    if (!rawTableKey) return undefined;
    if (rawTableKey.length <= 90) return rawTableKey;
    const hashed = `${rawTableKey.slice(0, 80)}_${hashKey(rawTableKey)}`;
    return hashed.slice(0, 100);
  }, [rawTableKey]);

  return { rawTableKey, tableKey };
}
